export default __webpack_public_path__ + "static/media/image3.5a55549e.png";